"use client"
// import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row, Input, Form, FormFeedback, Button, Spinner, Table, CardTitle, FormGroup } from "reactstrap";
import { Label, InputGroup, Card, CardBody, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FieldArray, FormikProvider } from "formik";
import fn_helper from "helpers/fn_helper";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import MyEditorCompact from "components/MyEditorCompact";

const CardPieceWorldclass = ({
    pageView,
    validation,
    cardNumber,
    contentCardShow,
    runningNo = 0
}) => {
    let cardRef = useRef(null);

    useEffect(() => {
        if(cardRef !== null) {
            cardRef.current.checked = contentCardShow;
        }
    }, [cardRef])

    const checkValue = validation?.values[`contentCard${cardNumber}Show`] ?? false

    return (
        <>
            <Col md={6}>
                <Card color="light">
                    <CardBody className="p-2">
                        <CardTitle className="m-0">
                            <FormGroup className="align-middle" switch>
                                <Input
                                    innerRef={cardRef}
                                    id={`contentCard${cardNumber}Show`}
                                    type="switch"
                                    role="switch"
                                    name={`contentCard${cardNumber}Show`}
                                    checked={checkValue}
                                    onClick={e => {
                                        const oldValue = checkValue
                                        validation.setFieldValue(`contentCard${cardNumber}Show`, !oldValue)
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched[`contentCard${cardNumber}Show`] &&
                                            validation.errors[`contentCard${cardNumber}Show`]
                                            ? true
                                            : false
                                }
                                    disabled={pageView === "view"}
                                />
                                <Label className="align-middle m-0" htmlFor={`contentCard${cardNumber}Show`}>
                                    <span className="align-middle">Card {runningNo} {validation.values[`contentCard${cardNumber}Show`]}</span>
                                    <i className="bx bxs-grid drag-handle align-middle" style={{ cursor: "grab" }} />
                                </Label>
                            </FormGroup>
                        </CardTitle>
                    </CardBody>
                    <CardBody className="p-1">
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item p-2">
                                <Col md={12}>
                                    <PopupAttachment
                                        typeDetail="single"
                                        typeUpload="ImageMap"
                                        upload="Image"
                                        prefixName={`section-worldclass-card${cardNumber}`}
                                        label="Image"
                                        required={false}
                                        description="description"
                                        widthSize={480}
                                        heightSize={300}
                                        value={validation.values[`card${cardNumber}Image`]}
                                        onChange={(value = {}, index) => {
                                            console.log("🚀 onChange ~ value:", value)
                                            console.log("🚀 onChange ~ index:", index)
                                            validation.setFieldValue(`card${cardNumber}Image`, value)
                                        }}
                                        onRemove={(index) => {
                                            console.log("🚀 onChange ~ index:", index)
                                            validation.setFieldValue(`card${cardNumber}Image`, {})
                                        }}
                                    />
                                    {validation.touched[`card${cardNumber}Image`] && validation.errors[`card${cardNumber}Image`] && (
                                        <div type="invalid" className="invalid-feedback d-block">
                                            {validation.errors[`card${cardNumber}Image`]}
                                        </div>
                                    )}
                                </Col>
                            </li>
                            <li className="list-group-item p-2">
                                <label
                                    htmlFor={`contentCard${cardNumber}Title`}
                                    className="col-md-12 col-form-label"
                                >
                                    Title
                                </label>
                                <div className="col-md-12">
                                    <Input
                                        id={`contentCard${cardNumber}Title`}
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name={`contentCard${cardNumber}Title`}
                                        onChange={e => {
                                            validation.setFieldValue(
                                                `contentCard${cardNumber}Title`,
                                                e.target.value
                                            )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`contentCard${cardNumber}Title`]}
                                        invalid={
                                            validation.touched[`contentCard${cardNumber}Title`] &&
                                                validation.errors[`contentCard${cardNumber}Title`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                    />
                                    {validation.touched[`contentCard${cardNumber}Title`] &&
                                        validation.errors[`contentCard${cardNumber}Title`] && (
                                            <FormFeedback type="invalid">
                                                {validation.errors[`contentCard${cardNumber}Title`]}
                                            </FormFeedback>
                                        )}
                                </div>
                            </li>

                            <li className="list-group-item p-2">
                                <Label
                                    htmlFor={`contentCard${cardNumber}Detail`}
                                    className="col-md-12 col-form-label"
                                >
                                    Detail
                                    <span className="t-require">*</span>
                                </Label>
                                <Col md={12}>
                                    <MyEditorCompact
                                        id={`contentCard${cardNumber}Detail`}
                                        placeholder=""
                                        name={`contentCard${cardNumber}Detail`}
                                        onChange={(e, editor) => {
                                            const data = editor.getData()
                                            validation.setFieldValue(
                                                `contentCard${cardNumber}Detail`,
                                                data
                                            )
                                            console.log({ e, editor, data })
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`contentCard${cardNumber}Detail`]}
                                        invalid={
                                            validation.touched[`contentCard${cardNumber}Detail`] &&
                                                validation.errors[`contentCard${cardNumber}Detail`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                        isError={
                                            validation.touched[`contentCard${cardNumber}Detail`] &&
                                                validation.errors[`contentCard${cardNumber}Detail`]
                                                ? true
                                                : false
                                        }
                                        onReady={(editor) => {
                                            editor.editing.view.change((writer) => {
                                                writer.setStyle(
                                                    "height",
                                                    "100px !important",
                                                    editor.editing.view.document.getRoot()
                                                );
                                            });
                                        }}
                                    />
                                </Col>
                            </li>
                        </ul>
                        
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}
export default CardPieceWorldclass